import {
  Column,
  CreateDateColumn,
  DeleteDateColumn,
  Entity,
  JoinColumn,
  ManyToOne,
  PrimaryGeneratedColumn
} from 'typeorm';
import { Cliente } from './Cliente';

@Entity()
export class Endereco {
  @PrimaryGeneratedColumn()
  id!: number;

  @Column({ nullable: false })
  apelido: string = '';

  @Column({ nullable: false })
  logradouro: string = '';

  @Column()
  numero: string = '';

  @Column({ nullable: false })
  complemento: string = '';

  @Column({ nullable: false })
  referencia: string = '';

  @Column({ nullable: false })
  cep: string = '';

  @Column({ nullable: false })
  cidade: string = '';

  @Column({ nullable: false })
  bairro: string = '';

  @Column({ nullable: false })
  clienteId!: number;

  @Column({ nullable: false })
  inativo: boolean = false;

  // @ManyToOne(() => Cidade, { nullable: false })
  // cidade!: Cidade;

  // @ManyToOne(() => Bairro, { nullable: false })
  // bairro!: Bairro;

  @ManyToOne(() => Cliente, { nullable: false })
  @JoinColumn({ name: 'clienteId' })
  cliente!: Cliente;

  @CreateDateColumn({ select: false })
  createdAt!: Date;

  @DeleteDateColumn({ select: false })
  deletedAt!: Date;
}

export default Endereco;
